export default {
    'name': 'dash',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M20 11H4V13H20V11Z\' fill=\'#026958\'/>'
}
